// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Input, OnInit } from '@angular/core';
import { ISubscription } from '../../../../types/subscription';
import { Observable } from 'rxjs';
import { IManageUser, UserRole } from '../../../../types/user';
import { selectUser } from '../../../store/user/user.selectors';
import { IIncludedSoftware } from '../products.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app.state';
import { HeaderService } from '../../../header.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-fde-sub',
    templateUrl: './fde-sub.component.html',
    styleUrls: ['./fde-sub.component.scss', '../products.component.scss'],
    standalone: false
})
export class FdeSubComponent implements OnInit {
  @Input() subscription: ISubscription;
  @Input() title: string;
  columnsToDisplay = ['productName', 'assignedLicenses', 'purchasedQuantity'];
  user$: Observable<IManageUser> = this.store.select(selectUser());
  data: IIncludedSoftware[] = [];
  protected readonly UserRole = UserRole;

  constructor(private readonly store: Store<AppState>,
              private readonly headerService: HeaderService,
              private readonly translate: TranslateService) {}

  ngOnInit() {
      this.data = [
        {
          productName: this.translate.instant('product_and_plan.plan.fde-label'),
          assignedLicenses: this?.subscription?.fde_used ?? 0,
          licensesApply: true,
          purchasedQuantity: this?.subscription?.count ?? 0,
          hasEndpoints: false,
          canAssign: true,
          hiddenForPartners: [],
        }
      ];
  }
}
